import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function formValueContainsNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regex = /\d/;
    return regex.test(control.value) ? null : { NoContainNumber: true };
  };
}
